import { createSlice } from "@reduxjs/toolkit";
import {
  ORDER_STATUS,
  ORDER_STATUS_SERVER,
} from "../components/UnifiedControlPlane/UnifiedControlPlane.constants";

const filterOrdersByStatus = (ordersData) => {

  const allOrders = ordersData;

  const getOrderAssignments = (orderAssignments) => {
    return (orderAssignments && orderAssignments.length) > 0
      ? orderAssignments.flatMap(
        (orderAssignment) => orderAssignment
      )
      : [];
  };

  const getGroundStationAssignments = (groundAssignments) => {
    return (groundAssignments && groundAssignments.length) > 0
      ? groundAssignments.flatMap(
        (groundAssignment) => groundAssignment
      )
      : [];
  };

  let updatedAllOrders = [];
  updatedAllOrders =
    allOrders &&
    allOrders.length > 0 &&
    allOrders.map((order) => {
      const displayAssignments =
        Object.keys(order.status.schedule).length > 0
          ? [
            ...getOrderAssignments(order.status.schedule.orderAssignments),
            ...getGroundStationAssignments(
              order.status.schedule.groundAssignments
            ),
          ]
          : [];

      return {
        ...order,
        status: {
          ...order.status,
          schedule: {
            ...order.status.schedule,
            displayAssignments: displayAssignments,
          },
        },
      };
    });

  const filteredOrders = {
    executed: [],
    current: [],
    pending: [],
  };

  updatedAllOrders &&
    updatedAllOrders.length > 0 &&
    updatedAllOrders.forEach((order) => {
      switch (order.status.state) {
        case ORDER_STATUS_SERVER.EXECUTED:
          filteredOrders.executed.push(order);
          break;
        case ORDER_STATUS_SERVER.CURRENT:
          filteredOrders.current.push(order);
          break;
        case ORDER_STATUS_SERVER.PENDING:
        case ORDER_STATUS_SERVER.PREVIEW:
          filteredOrders.pending.push(order);
          break;
        default:
          break;
      }
    });

  return filteredOrders;
};

const initialState = {
  scenarioId: null,
  ordersLoading: false,
  orders: {
    executed: [],
    current: [],
    pending: [],
  },
  creatingOrder: false,
  activeOrdersSection: ORDER_STATUS.CURRENT,
  showMapBoxMap: false,
  aoiCollection: {},
  uploadedCollection: {},

  groups: [],
  allGroundStations: [],
  highlightedOrderAssign: {},

  generatingSchedule: false,
  isScheduleGenerationComplete: true,
  fetchingSchedule: false,
  updatingSchedule: false,
  scheduleData: [],

  fetchingCurrentSchedule: false,
  currentScheduleData: [],

  fetchingAllSchedules: false,
  schedules: null,

  deletingSchedule: false,

  fetchingOrderAssignments: false,
  orderAssignments: [],

  showSingleOrderView: false,
  selectedOrderData: {},

  previewScheduleId: "",

  fetchingOAForSingleOrder: false,
  singleOrderAssignments: [],

  notification: {
    isSuccess: false,
    isError: false,
    isGenerating: false,
    isGenerated: false,
    showGeneratingPopup: false,
    message: "",
  },
  simulationClockFlag: false, //Simulation time received flag
  scenarioCurrentTime: "", //scenario current time
  orbitApiCalled: false, //orbit api for scenario flag
  mapLoading: false, //Loader to the map
  scenarioMultiplier: null, //scenario time scaling factor
  selectedScenario: {},
  predictionDataResponse: {},
  presimData: {
    predictionData: null,
    satelliteGroups: [],
    selectedGroup: null,
    selectedSatellite: null,
  },
  allowPresimAnalyze: false,
  fetchingAllScenarios: false,
  allScenarios: [],
  scheduleDashboardView: false,
  showReviewSchedulePopup: "",
  generatedScheduleId: "",
  showGenerateScheduleConfig: false,

  fetchingCurrentUcpConfig: false,
  settingCurrentUcpConfig: false,
  currentUcpConfig: {},

  disconnectingScenario: false,

  showConfirmationModal: false,
  showScenarioConfigDropdown: false,
  fidelity: 'low',
};

export const unifiedControlPlaneSlice = createSlice({
  name: "ucpSlice",
  initialState,
  reducers: {
    getOrdersRequest: (state) => {
      state.ordersLoading = true;
    },
    getOrdersSuccess: (state, action) => {
      state.orders = filterOrdersByStatus(action.payload);
      state.ordersLoading = false;
    },
    getOrdersFailure: (state) => {
      state.ordersLoading = false;
    },
    createOrderRequest: (state) => {
      state.creatingOrder = true;
    },
    createOrderSuccess: (state, action) => {
      // const orderData = action.payload;
      state.creatingOrder = false;
      state.notification = {
        isSuccess: true,
        isError: false,
        // message: `${orderData?.spec?.name ? orderData?.spec?.name : 'Order'} Created`,
        message: `Order Created`,
      };
    },
    createOrderFailure: (state) => {
      state.creatingOrder = false;
      state.notification = {
        isSuccess: false,
        isError: true,
        message: "Order Creation Failed",
      };
    },
    updateOrderRequest: (state) => {
      state.updatingOrder = true;
    },
    updateOrderSuccess: (state) => {
      state.updatingOrder = false;
    },
    updateOrderFailure: (state) => {
      state.updatingOrder = false;
    },
    deleteOrderRequest: (state) => {
      state.deletingOrder = true;
    },
    deleteOrderSuccess: (state, action) => {
      state.deletingOrder = false;
      // const orderName = action.payload;
      state.notification = {
        isSuccess: true,
        isError: false,
        // message: `${orderName ? orderName : 'Order'} Deleted`,
        message: `Order Deleted`,
      };
    },
    deleteOrderFailure: (state) => {
      state.deletingOrder = false;
      state.notification = {
        isSuccess: false,
        isError: true,
        message: "Order Deletion Failed",
      };
    },
    getOrderAssignmentsRequest: (state) => {
      state.fetchingOrderAssignments = true;
      state.orderAssignments = [];
    },
    getOrderAssignmentsSuccess: (state, action) => {
      state.fetchingOrderAssignments = false;
      state.orderAssignments = action.payload;
    },
    getOrderAssignmentsFailure: (state) => {
      state.fetchingOrderAssignments = false;
      state.orderAssignments = [];
    },
    getOrderAssignmentsForSingleOrderRequest: (state) => {
      state.fetchingOAForSingleOrder = true;
    },
    getOrderAssignmentsForSingleOrderSuccess: (state, action) => {
      state.fetchingOAForSingleOrder = false;
      state.singleOrderAssignments = action.payload;
    },
    getOrderAssignmentsForSingleOrderFailure: (state) => {
      state.fetchingOAForSingleOrder = false;
      state.singleOrderAssignments = [];
    },
    resetOrderAssignmentsForSingleOrder: (state) => {
      state.singleOrderAssignments = [];
    },
    setShowMapBoxMap: (state, action) => {
      state.showMapBoxMap = action.payload;
    },
    setUploadedFeatures: (state, action) => {
      state.uploadedCollection = action.payload;
    },
    resetUploadedFeatures: (state) => {
      state.uploadedCollection = {};
    },
    setOrdersSection: (state, action) => {
      state.activeOrdersSection = action.payload;
    },
    getGroupRequest: (state) => { },
    getGroupSuccess: (state, action) => {
      state.groups = action.payload;
    },
    getGroupFailure: (state) => { },

    getGroundStationRequest: (state) => { },
    getGroundStationSuccess: (state, action) => {
      state.allGroundStations = action.payload;
    },
    getGroundStationFailure: (state) => { },
    setHighlightedOrderAssign: (state, action) => {
      state.highlightedOrderAssign = action.payload;
    },
    resetHighlightedOrderAssign: (state) => {
      state.highlightedOrderAssign = {};
    },
    genrateScheduleRequest: (state) => {
      state.generatingSchedule = true;
    },
    genrateScheduleSuccess: (state, action) => {
      state.generatingSchedule = false;
      state.notification = {
        isSuccess: true,
        isError: false,
        isGenerating: true,
        showGeneratingPopup: true,
        message: "Schedule Generation In-Progress",
      };
      state.isScheduleGenerationComplete = false;
      state.generatedScheduleId = action.payload?.scheduleId || "";
    },
    genrateScheduleFailure: (state) => {
      state.generatingSchedule = false;
      state.notification = {
        isSuccess: false,
        isError: true,
        isGenerating: false,
        showGeneratingPopup: false,
        message: "Schedule Generation Failed",
      };
    },
    updateScheduleRequest: (state) => {
      state.updatingSchedule = true;
    },
    updateScheduleSuccess: (state, data) => {
      const { action } = data.payload;
      state.updatingSchedule = false;
      if (action === "Approve") {
        state.notification = {
          isSuccess: true,
          isError: false,
          //message: `${schedule?.label ? schedule?.label : 'Schedule'} Approved`,
          message: `Schedule approved, submitted for tasking and ground schedule submitted to UGP`,
        };
      }
      if (action === "Reject") {
        state.notification = {
          isSuccess: true,
          isError: false,
          // message: `${schedule?.label ? schedule?.label : 'Schedule'} Rejected`,
          message: `Schedule Rejected`,
        };
      }
    },
    updateScheduleFailure: (state, data) => {
      const { action, error } = data.payload;
      state.updatingSchedule = false;
      if (action === "Approve") {
        state.notification = {
          isSuccess: false,
          isError: true,
          message: error ? error : "Schedule Approval Failed",
        };
      }
      if (action === "Reject") {
        state.notification = {
          isSuccess: false,
          isError: true,
          message: error ? error : "Schedule Rejection Failed",
        };
      }
      if (action === "Simulate") {
        state.notification = {
          isSuccess: false,
          isError: true,
          message: error ? error : "Action Simulate Failed",
        };
      }
    },
    getScheduleRequest: (state) => {
      state.fetchingSchedule = true;
    },
    getScheduleSuccess: (state, action) => {
      state.fetchingSchedule = false;
      state.scheduleData = action.payload;
      if (action.payload?.state === "Draft" || action.payload?.state === "Experimental") {
        state.notification = {
          isSuccess: true,
          isError: false,
          isGenerating: false,
          isGenerated: true,
          showGeneratingPopup: false,
          message: "Schedule Generated",
        };
        state.generatedScheduleId = "";
        state.isScheduleGenerationComplete = true;
      } else if (action.payload?.state === "Empty") {
        state.notification = {
          isSuccess: false,
          isError: true,
          isGenerating: false,
          isGenerated: true,
          showGeneratingPopup: false,
          message: "Schedule Generated with no opportunities",
        };
        state.generatedScheduleId = "";
        state.isScheduleGenerationComplete = true;
        state.showGenerateScheduleConfig = true;
      }
    },
    getScheduleFailure: (state) => {
      state.fetchingSchedule = false;
      state.scheduleData = [];
    },
    getCurrentScheduleRequest: (state) => {
      state.fetchingCurrentSchedule = true;
    },
    getCurrentScheduleSuccess: (state, action) => {
      state.fetchingCurrentSchedule = false;
      state.currentScheduleData = action.payload;
    },
    getCurrentScheduleFailure: (state) => {
      state.fetchingCurrentSchedule = false;
      state.currentScheduleData = [];
      state.orderAssignments = [];
    },
    getAllScheduleRequest: (state) => {
      state.fetchingAllSchedules = true;
    },
    getAllScheduleSuccess: (state, action) => {
      state.fetchingAllSchedules = false;
      // if (state.schedules && (state.schedules?.length < action.payload?.length)) {
      //     state.notification = {
      //         isSuccess: true,
      //         isError: false,
      //         isGenerating: false,
      //         isGenerated: true,
      //         showGeneratingPopup: false,
      //         message: 'Schedule Generated',
      //     };
      //     state.isScheduleGenerationComplete = true;
      // }
      state.schedules = action.payload;
    },
    getAllScheduleFailure: (state) => {
      state.fetchingAllSchedules = false;
      state.isScheduleGenerationComplete = true;
      state.schedules = [];
    },
    deleteScheduleRequest: (state) => {
      state.deletingSchedule = true;
    },
    deleteScheduleSuccess: (state, data) => {
      const { action, schedule } = data.payload;
      state.deletingSchedule = false;
      if (action === "Delete") {
        state.schedules = state.schedules.filter(
          (item) => item.scheduleId !== schedule.scheduleId
        );

        state.notification = {
          isSuccess: true,
          isError: false,
          // message: `${schedule?.label ? schedule?.label : 'Schedule'} Deleted`,
          message: `Schedule Deleted`,
        };
      }
    },
    deleteScheduleFailure: (state, data) => {
      const { action } = data.payload;
      state.deletingSchedule = false;
      if (action === "Delete") {
        state.notification = {
          isSuccess: false,
          isError: true,
          message: "Schedule Delete Failed",
        };
      }
      if (action === "Discard") {
        state.notification = {
          isSuccess: false,
          isError: true,
          message: "Schedule Discard Failed",
        };
      }
    },
    setSingleOrderView: (state, action) => {
      state.showSingleOrderView = action.payload;
    },
    setSelectedOrderData: (state, action) => {
      state.selectedOrderData = action.payload;
    },
    resetSelectedOrderData: (state) => {
      state.selectedOrderData = {};
    },
    setPreviewScheduleId: (state, action) => {
      state.previewScheduleId = action.payload;
    },
    clearNotification: (state) => {
      state.notification = {
        isSuccess: false,
        isError: false,
        isGenerating: false,
        showGeneratingPopup: false,
        isGenerated: false,
        message: "",
      };
    },
    hideGeneratingPopup: (state) => {
      state.notification = {
        ...state.notification,
        showGeneratingPopup: false,
      };
    },
    setScenarioCurrentTime: (state, action) => {
      //reducer to set current scenario time
      state.scenarioCurrentTime = action.payload;
    },
    setAPIcalled: (state, action) => {
      //reducer to set that orbit api called
      state.orbitApiCalled = action.payload;
    },
    setSimulationClockFlag: (state, action) => {
      //reducer to set the flag that current scenario time received
      state.simulationClockFlag = action.payload;
    },
    setMapLoading: (state, action) => {
      //reducer to set loader to the map
      state.mapLoading = action?.payload;
    },
    setScenarioId: (state, action) => {
      state.scenarioId = action.payload;
    },
    setScenarioMultiplier: (state, action) => {
      //reducer to set time scaling for scenario
      state.scenarioMultiplier = action?.payload;
    },
    setSelectedScenario: (state, action) => {
      state.selectedScenario = action.payload || {};
    },
    postPredictionDataRequest: () => { },
    postPredictionDataSuccess: () => { },
    postPredictionDataFailure: () => { },
    getPredictionDataRequest: () => { },
    getPredictionDataSuccess: (state, action) => {
      state.predictionDataResponse = action.payload;
    },
    getPredictionDataFailure: () => { },
    setDefaultPredictionData: (state, action) => {
      const scenario = action.payload;
      const satelliteGroups = scenario?.satelliteGroups || [];

      const groups = satelliteGroups.map((group) => ({
        label: group?.satelliteGroupName,
        value: {
          color: group?.color,
          groupId: group?.satelliteGroupId,
          satellites: group?.satellites.map((sat) => ({
            label: sat?.satelliteName,
            value: {
              satId: sat?.satelliteId,
              satName: sat?.satelliteName,
            },
          })),
        },
      }));

      const prediction = {};
      satelliteGroups.forEach((group) => {
        group.satellites.forEach((sat) => {
          if (!prediction[sat?.satelliteId]) {
            prediction[sat?.satelliteId] = {
              state: "pending",
              data: {
                agilityUrl: [],
                powerUrl: [],
                dataFlowUrl: [],
              },
            };
          }
        });
      });

      // Retain previous selection
      const prevGroupId = state.presimData.selectedGroup?.value?.groupId;
      const prevSatId = state.presimData.selectedSatellite?.value?.satId;

      const selectedGroup =
        groups.find((group) => group?.value?.groupId === prevGroupId) ||
        groups[0];
      const selectedSatellite =
        selectedGroup?.value?.satellites.find(
          (sat) => sat?.value?.satId === prevSatId
        ) || selectedGroup?.value?.satellites[0];

      if (groups && selectedGroup && selectedSatellite) {
        state.presimData.predictionData = prediction;
        state.presimData.satelliteGroups = groups;
        state.presimData.selectedGroup = selectedGroup;
        state.presimData.selectedSatellite = selectedSatellite;
      } else {
        state.presimData.predictionData = null;
        state.presimData.satelliteGroups = [];
        state.presimData.selectedGroup = null;
        state.presimData.selectedSatellite = null;
      }
    },

    setDefaultPredictionForSatellite: (state, action) => {
      const { satelliteId, status } = action.payload;

      if (!state.presimData.predictionData) {
        state.presimData.predictionData = {};
      }

      const prev = state.presimData.predictionData[satelliteId] || {
        data: {
          agilityUrl: [],
          powerUrl: [],
          dataFlowUrl: [],
        },
      };

      state.presimData.predictionData[satelliteId] = {
        ...prev,
        state: status,
        data: {
          agilityUrl: prev.data.agilityUrl || [],
          powerUrl: prev.data.powerUrl || [],
          dataFlowUrl: prev.data.dataFlowUrl || [],
        },
      };
    },

    updatePredictionDataForSatellite: (state, action) => {
      const { satelliteId, agilityUrl, powerUrl, dataFlowUrl } = action.payload;

      if (!state.presimData.predictionData) {
        state.presimData.predictionData = {};
      }

      const prev = state.presimData.predictionData[satelliteId] || {};

      state.presimData.predictionData[satelliteId] = {
        ...prev,
        state: "success",
        data: {
          agilityUrl,
          powerUrl,
          dataFlowUrl,
        },
      };
    },

    setSelectedGroup: (state, action) => {
      state.presimData.selectedGroup = action.payload;
    },

    setSelectedSatellite: (state, action) => {
      state.presimData.selectedSatellite = action.payload;
    },
    setAllowPresimAnalyze: (state, action) => {
      state.allowPresimAnalyze = action.payload;
    },
    showScenarioErrorNotification: (state, action) => {
      state.notification = {
        isSuccess: false,
        isError: true,
        isGenerating: false,
        showGeneratingPopup: false,
        message: action.payload,
      };
    },
    setScheduleDashboardView: (state, action) => {
      state.scheduleDashboardView = action.payload;
    },
    setShowReviewSchedulePopup: (state, action) => {
      state.showReviewSchedulePopup = action.payload;
    },
    showErrorGenerateSchedulePopupConfig: (state, action) => {
      state.notification = {
        isSuccess: false,
        isError: true,
        message: action.payload || "Error in generate schedule config",
      };
    },
    setShowGenerateScheduleConfig: (state, action) => {
      state.showGenerateScheduleConfig = action.payload;
    },
    resetToInitialState: () => initialState,

    getCurrentUcpConfigRequest: (state) => {
      state.fetchingCurrentUcpConfig = true;
    },
    getCurrentUcpConfigSuccess: (state, action) => {
      state.fetchingCurrentUcpConfig = true;
      state.currentUcpConfig = action.payload
    },
    getCurrentUcpConfigError: (state) => {
      state.fetchingCurrentUcpConfig = false;
      state.currentUcpConfig = {};
    },

    setCurrentUcpConfigRequest: (state) => {
      state.settingCurrentUcpConfig = true;
    },
    setCurrentUcpConfigSuccess: (state, action) => {
      const { response, scenarioName } = action.payload;
      state.settingCurrentUcpConfig = false;
      state.currentUcpConfig = response;
      state.notification = {
        isSuccess: true,
        isError: false,
        message: `Connected to ${scenarioName}. Ready for data collection`,
      }
    },
    setCurrentUcpConfigError: (state) => {
      state.settingCurrentUcpConfig = false;
      state.notification = {
        isSuccess: false,
        isError: true,
        message: "Scenario connection failed",
      };
    },

    disconnectScenarioRequest: (state) => {
      state.disconnectingScenario = true;
    },
    disconnectScenarioSuccess: (state, action) => {
      const { scenarioName } = action.payload;
      state.disconnectingScenario = false;
      state.currentUcpConfig = null;
      state.notification = {
        isSuccess: true,
        isError: false,
        message: `${scenarioName} disconnected`
      }
    },
    disconnectScenarioFailure: (state) => {
      state.disconnectingScenario = false;
      state.notification = {
        isSuccess: false,
        isError: true,
        message: "Scenario disconnection failed",
      };
    },

    resetScenarioData: (state) => {
      state.scenarioId = null;
      state.selectedScenario = {};
      state.scenarioMultiplier = null;
      state.groups = [];
      state.scenarioCurrentTime = "";
      state.simulationClockFlag = false;
    },

    setShowConfirmationModal: (state, action) => {
      state.showConfirmationModal = action.payload;
    },
    setShowScenarioConfigDropdown: (state, action) => {
      state.showScenarioConfigDropdown = action.payload
    },

    getAllScenariosRequest: (state) => {
      state.fetchingAllScenarios = true;
    },
    getAllScenariosSuccess: (state, action) => {
      state.fetchingAllScenarios = false;
      state.allScenarios = action.payload;
    },
    getAllScenariosError: (state, action) => {
      state.fetchingAllScenarios = false;
      state.notification = {
        isSuccess: false,
        isError: true,
        message: action.payload
      }
    },
    setFidelity: (state, action) => {
      state.fidelity = action.payload
    },
    removeOrderImmediately: (state, action) => {
      const orderId = action.payload;
      state.orders.executed = state.orders.executed.filter(o => o.orderId !== orderId);
      state.orders.current  = state.orders.current.filter(o => o.orderId !== orderId);
      state.orders.pending  = state.orders.pending.filter(o => o.orderId !== orderId);
    },
  },
});

export const {
  getOrdersRequest,
  getOrdersSuccess,
  getOrdersFailure,

  createOrderRequest,
  createOrderSuccess,
  createOrderFailure,

  updateOrderRequest,
  updateOrderSuccess,
  updateOrderFailure,

  deleteOrderRequest,
  deleteOrderSuccess,
  deleteOrderFailure,

  getOrderAssignmentsRequest,
  getOrderAssignmentsSuccess,
  getOrderAssignmentsFailure,

  getOrderAssignmentsForSingleOrderRequest,
  getOrderAssignmentsForSingleOrderSuccess,
  getOrderAssignmentsForSingleOrderFailure,
  resetOrderAssignmentsForSingleOrder,

  setShowMapBoxMap,
  setUploadedFeatures,
  resetUploadedFeatures,
  setOrdersSection,

  getGroupRequest,
  getGroupSuccess,
  getGroupFailure,

  getGroundStationRequest,
  getGroundStationSuccess,
  getGroundStationFailure,

  setHighlightedOrderAssign,
  resetHighlightedOrderAssign,

  genrateScheduleRequest,
  genrateScheduleSuccess,
  genrateScheduleFailure,

  getScheduleRequest,
  getScheduleSuccess,
  getScheduleFailure,

  updateScheduleRequest,
  updateScheduleSuccess,
  updateScheduleFailure,

  getCurrentScheduleRequest,
  getCurrentScheduleSuccess,
  getCurrentScheduleFailure,

  getAllScheduleRequest,
  getAllScheduleSuccess,
  getAllScheduleFailure,

  deleteScheduleRequest,
  deleteScheduleSuccess,
  deleteScheduleFailure,

  setSingleOrderView,
  setSelectedOrderData,
  resetSelectedOrderData,

  setPreviewScheduleId,
  clearNotification,
  hideGeneratingPopup,

  //cesium scenario current time reducers
  setScenarioCurrentTime,
  setAPIcalled,
  setSimulationClockFlag,
  setMapLoading,
  setScenarioId,
  setScenarioMultiplier,
  setSelectedScenario,

  postPredictionDataRequest,
  postPredictionDataSuccess,
  postPredictionDataFailure,

  getPredictionDataRequest,
  getPredictionDataSuccess,
  getPredictionDataFailure,

  setDefaultPredictionData,
  setDefaultPredictionForSatellite,
  updatePredictionDataForSatellite,
  setSelectedGroup,
  setSelectedSatellite,
  setAllowPresimAnalyze,
  showScenarioErrorNotification,

  setScheduleDashboardView,
  setShowReviewSchedulePopup,

  setShowGenerateScheduleConfig,

  showErrorGenerateSchedulePopupConfig,

  resetToInitialState,

  getCurrentUcpConfigRequest,
  getCurrentUcpConfigSuccess,
  getCurrentUcpConfigError,

  setCurrentUcpConfigRequest,
  setCurrentUcpConfigSuccess,
  setCurrentUcpConfigError,

  disconnectScenarioRequest,
  disconnectScenarioSuccess,
  disconnectScenarioFailure,

  resetScenarioData,

  setShowConfirmationModal,

  setShowScenarioConfigDropdown,

  getAllScenariosRequest,
  getAllScenariosSuccess,
  getAllScenariosError,

  setFidelity,
  removeOrderImmediately

} = unifiedControlPlaneSlice.actions;

export default unifiedControlPlaneSlice.reducer;
